<template>
  <div class="container">
    <p>
      在检索框中可以通过题名、DOI、刊名、作者、出版社等字段的其中任一字段进行检索。
    </p>
    <img src="../../assets/images/newhelp/help2.png" alt="" />
    <p>
      检索结果左侧可按照学科和出版年、来源出版物分类聚合。选择需要的文献点击进入文章详情页面。
    </p>
    <img src="../../assets/images/newhelp/help3.png" alt="" />
    <p>点击全文获取按钮即可跳转对应网站获取全文。</p>
    <img src="../../assets/images/newhelp/help4.png" alt="" />
    <p>同时点击文献网络，还可查看此文章的参考文献、引证文献等文献资源。</p>
    <img src="../../assets/images/newhelp/help5.png" alt="" />
    <!-- <img src="../../assets/images/help/img2.png" alt="" /> -->
  </div>
</template>
<script>
export default {
  name: "Page1",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  padding: 75px;
  p,
  img {
    margin-bottom: 15px;
    font-size: 18px;
    max-width: 100%;
  }
}
</style>
